import { MonitoringAdapter } from "./MonitoringAdapter";
import { MonitoringUser } from "./types";

let adapter: MonitoringAdapter | null = null;

export const monitoring = {
  register: (a: MonitoringAdapter) => {
    adapter = a;
    adapter.init();
  },

  setUser: (user: MonitoringUser | null) => {
    adapter?.setUser?.(user);
  },
};

export type { MonitoringUser };
